import { GUARANTOR_LOGOUT } from "./Index";

export const _guarantorLogout = (
  ): any => async (dispatch: any) => {
    dispatch({
      type: GUARANTOR_LOGOUT,
      payload: {}
    });
  };